import React, { useCallback, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useFetch } from 'services/hooks';
import { Modal as AntdModal, Select } from 'antd';
import PropTypes from 'prop-types';
import Button from 'components/Button';

import './styles.less';

const { Option } = Select;

const I18N_BASE_PATH =
  'pages.private.KYBCompany.pages.companyDetails.components.modalSetRiskLevel';

const ModalSetRiskLevel = ({ setNewRiskLevel, transactionId }) => {
  const { t: translate } = useTranslation();

  const [modalVisible, setModalVisible] = useState(false);
  const [riskLevel, setRiskLevel] = useState();
  const { loading, post } = useFetch();

  const openModal = useCallback(() => setModalVisible(true), []);
  const closeModal = useCallback(() => setModalVisible(false), []);
  const onSaveRiskLevel = useCallback(async () => {
    // eslint-disable-next-line radix
    const newRiskLevel = parseInt(riskLevel);
    await post({
      url: `/executions/${transactionId}/transaction-records`,
      payload: {
        type: 'RISK_LEVEL',
        data: {
          riskLevel: newRiskLevel,
        },
      },
    });

    setModalVisible(false);
    setNewRiskLevel(newRiskLevel);
  }, [riskLevel, transactionId, post, setNewRiskLevel]);

  const Modal = useMemo(
    () => (
      <AntdModal
        width={700}
        footer={null}
        style={{ top: 40 }}
        onCancel={closeModal}
        visible={modalVisible}
        wrapClassName="caf-modal"
      >
        <div className="modal-set-risk-level-content">
          <h3>{translate(`${I18N_BASE_PATH}.title`, 'Risk level')}</h3>
          <span className="modal-set-risk-level-subtitle">
            {/* {translate(
              `${I18N_BASE_PATH}.subtitle`,
              'Lorem Ipsum has been the industries standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled.'
            )} */}
          </span>
          <div className="wrapper-select-risk-level">
            <Select
              style={{ width: 200, fontSize: '16px' }}
              placeholder={translate(
                `${I18N_BASE_PATH}.select.placeholder`,
                'Select the risk level'
              )}
              value={riskLevel}
              onChange={(v) => setRiskLevel(v)}
            >
              <Option value="0">
                {translate(`${I18N_BASE_PATH}.select.lowRisk`, 'Low Risk')}
              </Option>
              <Option value="50">
                {translate(`${I18N_BASE_PATH}.select.mediumRisk`, 'Medium Risk')}
              </Option>
              <Option value="100">
                {translate(`${I18N_BASE_PATH}.select.highRisk`, 'High Risk')}
              </Option>
            </Select>
          </div>
          <div className="wrapper-save-risk-level">
            <Button type="primary" onClick={onSaveRiskLevel} loading={loading}>
              {translate(`${I18N_BASE_PATH}.buttons.save`, 'Save')}
            </Button>
          </div>
        </div>
      </AntdModal>
    ),
    [closeModal, modalVisible, riskLevel, onSaveRiskLevel, translate, loading]
  );

  return { openModal, modalVisible, Modal };
};

export default ModalSetRiskLevel;

ModalSetRiskLevel.propTypes = {
  currentRiskLevel: PropTypes.string.isRequired,
  onChangeRiskLevel: PropTypes.func.isRequired,
};
